import BaseForm from '../base';
export class TotalFlowMetersPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
